<template>
    <!-- 实物线上邮寄用户信息录入弹窗 -->
    <van-dialog v-model="isVisibility"
        :show-confirm-button="false"
        class-name="vertical-center-modal"
        :overlayStyle="overlayStyle"
        :styles="{top: '100px'}">
        <div class="diyModal">
            <!--中奖内容文本-->
            <div class="awardContent">
                <div class="virtualOnline">请填写收件信息</div>
                <div class="customerInfo"
                    style="padding: 0 15px;">
                    <!-- 顾客姓名 -->
                    <van-cell-group class="group1">
                        <van-field v-if="!awardObj.extendConfigFlag"
                            v-model="modelFormCustom.userName"
                            size='large'
                            label-width="65px"
                            label="姓名"
                            @focus="isUserName=true"
                            @blur="isUserName=false"
                            :placeholder="!isUserName?'请输入姓名':''"
                            clearable />
                        <van-field v-else
                            v-model="awardObj.userName"
                            readonly
                            size='large'
                            label-width="65px"
                            label="姓名" />
                    </van-cell-group>
                    <!-- 顾客电话 -->
                    <van-cell-group>
                        <van-field v-if="!awardObj.extendConfigFlag"
                            v-model="modelFormCustom.userPhone"
                            size='large'
                            label-width="65px"
                            label="电话"
                            @focus="isUserPhone=true"
                            @blur="isUserPhone=false"
                            :placeholder="!isUserPhone?'请输入电话':''"
                            clearable />
                        <van-field v-else
                            v-model="awardObj.userPhone"
                            readonly
                            size='large'
                            label-width="65px"
                            label="电话" />
                    </van-cell-group>
                    <!-- 顾客地址 -->
                    <van-cell-group>
                        <van-field label="地址"
                            placeholder="请选择省份/城市/地区"
                            v-model="userAddress"
                            label-width="65px"
                            @click.stop="showAreaSelectDialog"
                            v-if="!awardObj.extendConfigFlag"
                            size='large'
                            readonly
                            clearable />
                        <van-field v-model="awardObj.userAddress"
                            readonly
                            v-if="awardObj.extendConfigFlag && awardObj.userAddress"
                            size='large'
                            label-width="65px"
                            label="地址" />
                    </van-cell-group>
                    <!-- 详细地址 -->
                    <van-cell-group>
                        <van-field label="详细地址"
                            @focus="isUserAddress=true"
                            @blur="isUserAddress=false"
                            :placeholder="!isUserAddress?'请输入详细地址':''"
                            v-model="modelFormCustom.userAddress"
                            label-width="65px"
                            v-if="!awardObj.extendConfigFlag"
                            maxlength="50"
                            size='large'
                            clearable />
                        <van-field v-model="awardObj.userAddressDetail"
                            readonly
                            v-if="awardObj.extendConfigFlag && awardObj.userAddressDetail"
                            size='large'
                            label-width="65px"
                            label="详细地址" />
                    </van-cell-group>
                </div>
                <div class="diyModalButtonText">
                    <van-button :disabled="isClick"
                        round
                        type="info"
                        @click="modalOk">{{ !awardObj.extendConfigFlag?'提交':'确定' }}</van-button>
                </div>
            </div>
            <div class="diyClose"
                @click="modalCancel(true)">
                <van-icon name="close" />
            </div>
        </div>
        <!-- 地址选择组件 -->
        <AreaSelect ref="areaSelect" @selectArea="handleGetAdd"></AreaSelect>
    </van-dialog>
</template>

<script>
import { config as configEnv } from '../../../src/commons/config.js';
import { ActionSheet, Area, Cell, CellGroup, Icon, Dialog, Field, Toast, Button } from 'vant';
import AreaSelect from '../../components/modal/area-select.vue'
export default {
  components: {
    [Dialog.Component.name]: Dialog.Component,
    [ActionSheet.name]: ActionSheet,
    [Area.name]: Area,
    [Cell.name]: Cell,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [Field.name]: Field,
    [Button.name]: Button,
    AreaSelect
  },
  props: {
    awardObj: Object,
    activityObj: Object,
    activityUrl: String,
    // 获取抽奖次数方式
    drawType: String,
    userBase: Object,
    goodsIndex: Number,
    overlayStyle: Object,
    isCloseMethods: Boolean,
  },
  data() {
    return {
      isVisibility: false,
      modelFormCustom: {
        userName: '',
        userPhone: '',
        userAddress: '',
        channelName: '',
        userCountryName: '中国',
        userProvinceName: '',
        userCityName: '',
        userZoneName: '',
      },
      isUserName: false,
      isUserPhone: false,
      isUserAddress: false,
      userAddress: '',
      isClick: false,
      errorTime: true,
      errorMessage: '',
      env: configEnv.env !== 'pro' ? 'trial' : 'release', // 判断当前环境变量，env-version默认正式版release，为方便测试增加体验版trial跳转
    };
  },
  created() {},
  mounted() {},
  methods: {
    modalOk() {
      if (this.awardObj.extendConfigFlag) {
        this.$emit('handleRealOnlineMailing');
        return;
      }
      const self = this;
      const obj = Object.assign({}, self.modelFormCustom);
      if (!obj.userName) {
        Toast('请输入姓名');
        return false;
      } else if (!obj.userPhone) {
        Toast('请输入电话');
        return false;
      } else if (!/^1[0-9]{10}$/.test(obj.userPhone)) {
        Toast('请输入正确的电话号码');
        return false;
      } else if (!this.userAddress) {
        Toast('请选择所在省市区');
        return false;
      } else if (!obj.userAddress) {
        Toast('请输入详细地址');
        return false;
      } else if (obj.userAddress.length < 5) {
        Toast('详细地址不能少于五个字符');
        return false;
      }
      if (this.isClick) return;
      this.isClick = true;
      const privacyKeys = {
        userName: '$PrivacyPlain$',
        userPhone: '$PrivacyPlain$',
        userAddress: '$PrivacyPlain$',
      };
      //隐私信息保存
      const privacyKeyLsit = [
        {
          userName: 'userName',
          typeText: 'NAME',
          labelText: 'mktMagicShareCpsUserName',
        },
        {
          userPhone: 'userPhone',
          typeText: 'MOBILE_PHONE_NO',
          labelText: 'mktStudentRewardRecodeUserPhone',
        },
        {
          userAddress: 'userAddress',
          typeText: 'ADDRESS',
          labelText: 'mktMagicShareCpsUserAddress',
        },
      ];
      self.$utils.privacySave(privacyKeys, privacyKeyLsit, obj);
      const params = {
        userName: obj.userName,
        userPhone: obj.userPhone,
        userAddress: obj.userAddress,
        userCountryName: obj.userCountryName,
        userProvinceName: obj.userProvinceName,
        userCityName: obj.userCityName,
        userZoneName: obj.userZoneName,
        referrFlag: sessionStorage.getItem('userType') === '2' ? '1' : '',
      };
      this.$emit('handleRealOnlineMailing', self.awardObj, self.goodsIndex, params);
    },
    showErrorMessage() {
      Toast(this.errorMessage);
    },
    modalCancel() {
      setTimeout(() => {
        this.isVisibility = false;
        if (this.isCloseMethods) this.$emit('closeEnd');
      }, 300);
    },
    nextStep() {
      this.$emit('nextStep');
    },
    async openModel(source) {
      this.isVisibility = true;
      if(!this.awardObj.extendConfigFlag){
        this.userAddress = ''
      }
      this.modelFormCustom = {
        userName: '',
        userPhone: '',
        userAddress: '',
        channelName: '',
        userCountryName: '中国',
        userProvinceName: '',
        userCityName: '',
        userZoneName: '',
      };
      this.isClick = false;
    },
    // 显示省市区选择弹窗
    showAreaSelectDialog(){
      this.$refs.areaSelect.showDialog()
    },
    // 保存选择的地址  area: 选择好的地址数据
    handleGetAdd(area) {
      let data = []
      area.forEach(item=>{
        let tempObj = {
          code : item.id,
          name : item.name
        }
        data.push(tempObj)
      })
      this.userAddress = `${data[0].name} / ${data[1].name} / ${data[2].name}`;
      console.log(this.userAddress);
      this.modelFormCustom.userProvinceName = data[0].name;
      this.modelFormCustom.userCityName = data[1].name;
      this.modelFormCustom.userZoneName = data[2].name;
    },
  },
};
</script>
<style lang="scss" scoped>
.van-button {
  width: 200px;
}
.van-dialog {
  width: 100%;
  overflow: initial;
  background-color: transparent;
  /deep/ .van-dialog__content {
    margin: 0;
    padding: 0;
    width: 100%;
    height: 111vh;
    display: flex;
    align-items: center;
    justify-content: center;
    .diyModal {
      width: 320px;
      height: auto;
      margin: auto;
      min-height: 245px;
      position: relative;
      z-index: 10;
      .awardContent {
        width: 95%;
        min-height: 120px;
        margin: 0 2.5%;
        background-image: linear-gradient(180deg, #ffffff 0%, #f8fbff 25% #f1f6ff 50%, #eaf1ff 75%, #e2ecff 100%);
        text-align: center;
        border-radius: 20px;
        margin-top: 20px;
        .virtualOnline {
          font-size: 20px;
          font-weight: 900;
          padding: 26px 0 0;
          color: #000;
        }
        .customerInfo {
          margin-top: 20px;
        }
        .van-cell-group {
          background-color: rgba(0, 0, 0, 0) !important;
          .van-cell {
            background-color: rgba(0, 0, 0, 0) !important;
          }
          .van-cell--large .van-cell__title {
            font-size: 14px;
          }
        }
        .van-cell-group::after {
          border-top: none;
          border-bottom: 1px solid #d5d6d8 !important;
        }
        .diyModalButtonText {
          margin-top: 40px;
          padding-bottom: 20px;
          .van-button {
            background-color: #256fff;
          }
        }
      }
      .diyClose {
        width: 30px;
        height: 30px;
        font-size: 36px;
        position: absolute;
        left: 50%;
        transform: translate(-50%, 0);
        bottom: -50px;
        z-index: 10000;
        color: #ffffff;
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/modal/real-online-mailing-modal.vue